// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kds-completed-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e2e8f0;
  padding: 16px 24px;
  box-sizing: border-box;
}

.kds-completed-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.kds-completed-header-text {
  font-size: calc(24px + var(--kds-font-delta, 0px));
  font-weight: 500;
  color: #0f172a;
  margin: 0;
  line-height: 1.2;
}

.kds-completed-order-count {
  font-size: calc(12px + var(--kds-font-delta, 0px));
  border-radius: 9999px;
  background-color: #f1f5f9;
  font-weight: 600;
  color: #64748b;
  padding: 4px 6px;
}

.kds-completed-close-btn {
  display: inline-flex;
  height: 32px;
  width: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
}

.kds-completed-close-btn:hover {
  background-color: #f1f5f9;
  color: #0f172a;
}

.kds-comp-search-container {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto 190px;
  gap: 12px;
  border-bottom: 1px solid #f1f5f9;
  background-color: rgba(248, 250, 252, 0.7);
  padding: 16px 24px;
  margin: 0;
  box-sizing: border-box;
  align-items: center;
}

.kds-input-container {
  display: flex;
  height: 44px;
  align-items: center;
  gap: 8px;
  border-radius: 50px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  padding: 0 12px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
}

.kds-search-bar {
  width: 100%;
  border: 0 !important;
  background: transparent !important;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  color: #334155;
  outline: none;
  padding: 0 !important;
  height: 100%;
  font-weight: 400;
}

.kds-search-bar::placeholder {
  color: #94a3b8;
}

.kds-input-container > *:first-child {
  position: static !important;
  transform: none !important;
  display: flex;
  align-items: center;
  color: #94a3b8 !important;
  pointer-events: none;
}

.kds-comp-date-container {
  position: relative;
  display: inline-flex;
  align-items: center;
}

/* Reused OdsDateFilter, sized to sit level with the 44px search box and source filter */
.kds-comp-date-container .ods-date-filter-pill {
  height: 44px;
  padding: 0 16px;
  border-radius: 50px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.kds-comp-date-container .ods-date-filter-pill:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}

.kds-comp-date-container .ods-date-filter-text {
  font-size: calc(14px + var(--kds-font-delta, 0px));
  font-weight: 500;
  color: #475569;
  letter-spacing: normal;
}

/* The pill sits mid-row — open the 280px calendar leftwards so it stays inside the drawer */
.kds-comp-date-container .ods-date-dropdown {
  left: auto;
  right: 0;
}

.kds-comp-fiter-container {
  width: 100%;
  flex-shrink: 0;
}

.kds-completed-card-board {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: rgba(241, 245, 249, 0.3);
  padding: 20px 24px;
  display: block;
  box-sizing: border-box;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

.kds-completed-card-board::-webkit-scrollbar {
  width: 6px;
}

.kds-completed-card-board::-webkit-scrollbar-track {
  background: transparent;
}

.kds-completed-card-board::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
  transition: background 0.2s ease;
}

.kds-completed-card-board::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.KdsCompLoaderContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: rgba(241, 245, 249, 0.3);
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/KDS/components/KdsCompletedModal/KdsCompletedModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gCAAgC;EAChC,0CAA0C;EAC1C,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kCAAkC;EAClC,kDAAkD;EAClD,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,wFAAwF;AACxF;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,4FAA4F;AAC5F;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;EACpC,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;AAC5C","sourcesContent":[".kds-completed-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #e2e8f0;\n  padding: 16px 24px;\n  box-sizing: border-box;\n}\n\n.kds-completed-header-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.kds-completed-header-text {\n  font-size: calc(24px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  color: #0f172a;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.kds-completed-order-count {\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  border-radius: 9999px;\n  background-color: #f1f5f9;\n  font-weight: 600;\n  color: #64748b;\n  padding: 4px 6px;\n}\n\n.kds-completed-close-btn {\n  display: inline-flex;\n  height: 32px;\n  width: 32px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  padding: 0;\n}\n\n.kds-completed-close-btn:hover {\n  background-color: #f1f5f9;\n  color: #0f172a;\n}\n\n.kds-comp-search-container {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto 190px;\n  gap: 12px;\n  border-bottom: 1px solid #f1f5f9;\n  background-color: rgba(248, 250, 252, 0.7);\n  padding: 16px 24px;\n  margin: 0;\n  box-sizing: border-box;\n  align-items: center;\n}\n\n.kds-input-container {\n  display: flex;\n  height: 44px;\n  align-items: center;\n  gap: 8px;\n  border-radius: 50px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  padding: 0 12px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  box-sizing: border-box;\n}\n\n.kds-search-bar {\n  width: 100%;\n  border: 0 !important;\n  background: transparent !important;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  color: #334155;\n  outline: none;\n  padding: 0 !important;\n  height: 100%;\n  font-weight: 400;\n}\n\n.kds-search-bar::placeholder {\n  color: #94a3b8;\n}\n\n.kds-input-container > *:first-child {\n  position: static !important;\n  transform: none !important;\n  display: flex;\n  align-items: center;\n  color: #94a3b8 !important;\n  pointer-events: none;\n}\n\n.kds-comp-date-container {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n/* Reused OdsDateFilter, sized to sit level with the 44px search box and source filter */\n.kds-comp-date-container .ods-date-filter-pill {\n  height: 44px;\n  padding: 0 16px;\n  border-radius: 50px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.kds-comp-date-container .ods-date-filter-pill:hover {\n  border-color: #cbd5e1;\n  background: #f8fafc;\n}\n\n.kds-comp-date-container .ods-date-filter-text {\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  color: #475569;\n  letter-spacing: normal;\n}\n\n/* The pill sits mid-row — open the 280px calendar leftwards so it stays inside the drawer */\n.kds-comp-date-container .ods-date-dropdown {\n  left: auto;\n  right: 0;\n}\n\n.kds-comp-fiter-container {\n  width: 100%;\n  flex-shrink: 0;\n}\n\n.kds-completed-card-board {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background-color: rgba(241, 245, 249, 0.3);\n  padding: 20px 24px;\n  display: block;\n  box-sizing: border-box;\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n}\n\n.kds-completed-card-board::-webkit-scrollbar {\n  width: 6px;\n}\n\n.kds-completed-card-board::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.kds-completed-card-board::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 10px;\n  transition: background 0.2s ease;\n}\n\n.kds-completed-card-board::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n.KdsCompLoaderContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  background-color: rgba(241, 245, 249, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
